import {
  FormValues,
  InputFieldProps,
  yupSchemaToValidationFunc
} from 'components/Forms';
import * as Yup from 'yup';
import JobType from 'models/JobTypes';
import { QueryParams } from 'store/utils';
import { DateTime } from 'luxon';

export const populateJobTypes = (jobTypes: JobType[]) => {
  return jobTypes.map(jobType => ({
    value: jobType.id,
    label: jobType.name,
    key: jobType.id,
    testId: 'jobTypeValue'
  }));
};

// We don't want to allow the creation of SMETS1 appointments https://ovotech.atlassian.net/browse/FTSC-1893
const unwantedJobTypeIds = [
  '3e8ad79b-1245-4b02-b009-4e4488319f5a',
  'e8c768b4-eb77-4222-b623-f2a1d469bd3d',
  '3c2f6906-5453-4816-9b35-afb89ebef0f9',
  // EnEx job types not intended for Aegis
  // PRD IDs
  '6873c092-76c9-49ef-917f-5b57157e8e7c',
  '0199b5eb-52b4-43e5-8e5f-18e287d29071',
  '21bbafd5-3bcb-4089-acce-64a07ace123e'
];
export const buildInitialFormFields = (
  jobTypes: JobType[]
): InputFieldProps[] => {
  const filteredJobTypes = jobTypes.filter(jobType => {
    return !unwantedJobTypeIds.includes(jobType.id);
  });

  return [
    {
      id: 'postcode',
      label: 'Postcode',
      name: 'postcode',
      qaId: 'addJobPostcode',
      inputType: 'textfield'
    },
    {
      id: 'jobType',
      label: 'Job Type',
      name: 'jobType',
      qaId: 'addJobJobType',
      inputType: 'select',
      options: populateJobTypes(filteredJobTypes)
    }
  ];
};

const initialFormFieldsValidation = Yup.object().shape({
  jobType: Yup.string().required('Required'),
  postcode: Yup.string().required('Required')
});

export const initialFormValidation = yupSchemaToValidationFunc(
  initialFormFieldsValidation
);

export const availabilityRequestEndDate = () =>
  DateTime.now()
    .plus({ days: 57 })
    .toISODate();

export const processAddJobFormFields = (
  values: FormValues,
  includeToday: boolean
): FormValues => {
  const date = DateTime.now().plus({ days: includeToday ? 0 : 1 });

  const queryParams: QueryParams = {
    startDate: {
      operator: '=',
      values: [date.toISODate()]
    },
    endDate: {
      operator: '=',
      values: [availabilityRequestEndDate()]
    },
    job_type: {
      operator: '=',
      values: [values.jobType as string]
    },
    postcode: {
      operator: '=',
      values: [values.postcode as string]
    }
  };

  return queryParams;
};
